import {useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {
    BottomNavigation,
    BottomNavigationAction,
    bottomNavigationActionClasses,
    Box,
    Button, ClickAwayListener,
    Divider,
    Fade,
    IconButton,
    InputAdornment,
    List, ListItem, ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    styled,
    Typography
} from "@mui/material";
import {Backup, ContentCopy, ContentCut, CreateNewFolder, CreateNewFolderOutlined, Delete, Download, FolderZip, MoreVertRounded, PanToolAltOutlined, PanToolAltRounded, SearchRounded, TagRounded, TouchAppOutlined, TouchAppRounded, UploadFileOutlined, UploadRounded} from "@mui/icons-material";
import {AnimatePresence, motion} from "framer-motion";
import FoldersBreadCrumb from "./foldersBreadCrumb";
import CustomInput from "../../../theme/components/CustomInput";
import LoadingSpinner from "../../loading/loadingSpinner";
import {searchInDrive} from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";

const Toolbar = (props) => {

    const {
        folders,
        selectedItems,
        setSelectedItems,
        setUploadFileModalOpen,
        setCreateFolderModal,
        multipleSelect,
        setMultipleSelect,
        setTransferType,
        handleDownloadFiles,
        handleDownloadFolder,
        setDeleteConfirmOpen,
        setTransferModalOpen,
        setShareModalOpen,
        setShareFolderModalOpen,
        setAddTagModal,
        pending,
        ...restProps
    } = props

    const [anchorEl, setAnchorEl] = useState(null);
    const actionsMenuOpen = Boolean(anchorEl);
    const isHaveFolders = Boolean(selectedItems?.filter(i => i.type === 'folder')?.length);

    const [searchInput, setSearchInput] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const searchQuery = searchParams.get('search');

    const [suggestions, setSuggestions] = useState([]);
    const [suggestionsLoading, setSuggestionsLoading] = useState(true);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [searching, setSearching] = useState(false);

    const {folderId} = useParams();
    const navigate = useNavigate();

    const handleToggleMultiple = () => {
        if (multipleSelect && selectedItems.length) setSelectedItems([selectedItems.pop()]);
        setMultipleSelect(!multipleSelect);
    }
    const handleOpenActionsMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseActionsMenu = () => {
        setAnchorEl(null);
    }

    const handleInputSearchChange = async(e) => {
        const {target: {value}} = e;
        setSearchInput(value);
        if (value?.length >= 3) {
            if (searching) return;
            setShowSuggestions(true);
            try {
                setSuggestionsLoading(true);
                setSearching(true);
                const {folders, files} =  await searchInDrive(value);
                setSuggestions([...folders?.map(i => i.name), ...files?.map(f => f.name)]);
                setSuggestionsLoading(false);
                setSearching(false);
            } catch (err) {
                console.log(err);
                Toasty.error('خطایی غیر منتظره رخ داد')
            }
        } else setShowSuggestions(false); setSearching(false);
    }
    const handleSearch = async (value) => {
        if (!value) return;
        // if (folderId) await navigate(`/drive`);
        // setSearchParams({search: value});
        navigate(`/drive?search=${value}`);
    }

    const ActionsMenu = () => {

        const totalItems = selectedItems?.length;
        const MenuComponent = ({children}) => {
            return (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={actionsMenuOpen}
                    onClose={handleCloseActionsMenu}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        sx: {minWidth: "12rem"}
                    }}>
                    {children}
                </Menu>
            )
        }

        switch (true) {
            // If it was one item selected
            case (totalItems <= 1): return (
                selectedItems[0].type !== 'folder'
                    ?
                    <MenuComponent>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setTransferType('move'); setTransferModalOpen(true)}}>
                            <ListItemIcon>
                                <ContentCut fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>انتقال</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setTransferType('copy'); setTransferModalOpen(true)}}>
                            <ListItemIcon>
                                <ContentCopy fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>کپی</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setDeleteConfirmOpen(true)}}>
                            <ListItemIcon>
                                <Delete color="error" fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>حذف</ListItemText>
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => {handleCloseActionsMenu(); handleDownloadFiles([selectedItems[0].id], selectedItems[0].name, false, true)}}>
                            <ListItemIcon>
                                <Download color="success" fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>دانلود</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setAddTagModal(true)}}>
                            <ListItemIcon>
                                <TagRounded color='info' fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>افزودن تگ</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setShareModalOpen(true)}}>
                            <ListItemIcon>
                                <Backup fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>اشتراک گذاری/ارسال مجدد</ListItemText>
                        </MenuItem>
                    </MenuComponent>
                    :
                    <MenuComponent>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setTransferType('move'); setTransferModalOpen(true)}}>
                            <ListItemIcon>
                                <ContentCut fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>انتقال</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setDeleteConfirmOpen(true)}}>
                            <ListItemIcon>
                                <Delete color="error" fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>حذف</ListItemText>
                        </MenuItem>
                        <Divider />
                        <MenuItem disabled={pending} onClick={async() => {await handleDownloadFolder(selectedItems[0].id, selectedItems[0].name, true); handleCloseActionsMenu();}}>
                            <ListItemIcon>
                                <FolderZip color="success" fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>دانلود به صورت فشرده</ListItemText>
                            <Fade in={pending}>
                                <Box ml={1}>
                                    <LoadingSpinner/>
                                </Box>
                            </Fade>
                        </MenuItem>
                        <MenuItem onClick={() => {handleCloseActionsMenu(); setShareFolderModalOpen(true)}}>
                            <ListItemIcon>
                                <Backup fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>اشتراک گذاری</ListItemText>
                        </MenuItem>
                    </MenuComponent>
            )
            // Default assumes there are multiple files selected
            default: return (
                <MenuComponent>
                    <MenuItem onClick={() => {handleCloseActionsMenu(); setTransferType('move'); setTransferModalOpen(true)}}>
                        <ListItemIcon>
                            <ContentCut fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>انتقال</ListItemText>
                    </MenuItem>
                    {!isHaveFolders && (
                        <>
                            <MenuItem onClick={() => {handleCloseActionsMenu(); setTransferType('copy'); setTransferModalOpen(true)}}>
                                <ListItemIcon>
                                    <ContentCopy fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>کپی</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {handleCloseActionsMenu(); handleDownloadFiles(selectedItems?.map(i => i.id), 'files.zip', true, true)}}>
                                <ListItemIcon>
                                    <FolderZip color="success" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>دانلود به صورت فشرده</ListItemText>
                            </MenuItem>
                        </>
                    )}
                    <MenuItem onClick={() => {handleCloseActionsMenu(); setDeleteConfirmOpen(true)}}>
                        <ListItemIcon>
                            <Delete color="error" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>حذف</ListItemText>
                    </MenuItem>
                    {!isHaveFolders && (
                        <>
                            <Divider/>
                            <MenuItem onClick={() => {handleCloseActionsMenu(); setShareModalOpen(true)}}>
                                <ListItemIcon>
                                    <Backup fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>اشتراک گذاری/ارسال مجدد</ListItemText>
                            </MenuItem>
                        </>
                    )}
                </MenuComponent>
            );
        }

    }

    // When folder Changes, empty search
    useEffect(() => {
        if (folderId) setSearchInput('');setShowSuggestions(false);
    }, [folderId]);

    return (
        <Root {...restProps}>
            <Box flex={1} mr={{ lg: 5 }} position="relative">
                <Box display="flex">
                    <FoldersBreadCrumb folders={folders}/>
                    <Fade in={!!searchQuery} sx={{ ml: 2.5 }}>
                        <Typography> عبارت جستجو شده: {searchQuery}</Typography>
                    </Fade>
                </Box>
                <Box
                    mt={1.5}
                    component="form"
                    onSubmit={(e) => {e.preventDefault(); handleSearch(searchInput)}}
                    position="relative">
                    <CustomInput
                        value={searchInput} onChange={handleInputSearchChange}
                        fullWidth
                        // onBlur={(e) => handleSearch(e.target.value)}
                        label="جستجو" placeholder="عبارت مورد نظر خود را وارد کنید"
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton type="submit"><SearchRounded fontSize="small"/></IconButton>
                            </InputAdornment>
                        }
                        sx={{ boxShadow: "none" }}/>
                    <ClickAwayListener onClickAway={() => setShowSuggestions(false)}>
                        <Fade in={showSuggestions} unmountOnExit>
                            <List sx={{ p: 0, position: "absolute", bottom: 0, right: 0, left: 0, transform: "translateY(95%)", background: theme => theme.palette.background.box, borderTop: "1px solid rgb(0 0 0 / 10%)", borderBottomRightRadius: 6, borderBottomLeftRadius: 6, maxHeight: "15rem", overflowY: "auto", boxShadow: "0 10px 12px -8px rgb(66 66 66 / 25%)", zIndex: 99 }}>
                                {suggestionsLoading
                                    ?
                                    <ListItem sx={{ borderRadius: "inherit", p: 2 }}>در حال بارگذاری... <LoadingSpinner/></ListItem>
                                    :
                                    suggestions.length
                                        ?
                                        suggestions.map((s, ind) => (
                                            <ListItemButton onClick={() => {setShowSuggestions(false);handleSearch(s)}} key={ind} sx={{ borderRadius: "inherit", p: 2 }}>{s}</ListItemButton>
                                        ))
                                        : <ListItem sx={{ borderRadius: "inherit", p: 2 }}>هیچ موردی یافت نشد!</ListItem>}
                            </List>
                        </Fade>
                    </ClickAwayListener>
                </Box>
            </Box>
            {/* Desktop Actions */}
            <Stack display={{xs: "none", lg: "flex"}} mt={{ xs: 2, lg: 0 }} direction={{lg: "row"}} height={1} alignSelf="flex-end" alignItems="center" rowGap={2} columnGap={2}>
                <Button onClick={() => setUploadFileModalOpen(true)} variant="contained" disableElevation startIcon={<UploadRounded/>} sx={{ width: {xs: "100%", lg: "auto"}, py: 1.5 }}>آپلود فایل جدید</Button>
                <Button onClick={() => setCreateFolderModal(true)} variant="contained" disableElevation startIcon={<CreateNewFolder/>} sx={{ width: {xs: "100%", lg: "auto"}, py: 1.5 }}>ایجاد پوشه جدید</Button>
                <Button onClick={handleToggleMultiple} variant="contained" disableElevation startIcon={multipleSelect ? <TouchAppRounded/> : <PanToolAltRounded/>} sx={{ width: {xs: "100%", lg: "auto"}, backgroundColor: theme => theme.palette.primary.dark, py: 1.5 }}>{multipleSelect ? "چند انتخابی" : "تک انتخابی"}</Button>
                <AnimatePresence>
                    {selectedItems.length ? (
                        <Stack component={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                            <IconButton id="basic-button"
                                        aria-controls={actionsMenuOpen ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={actionsMenuOpen ? 'true' : undefined}
                                        onClick={handleOpenActionsMenu}><MoreVertRounded/></IconButton>
                            <ActionsMenu/>
                        </Stack>
                    ): null}
                </AnimatePresence>
            </Stack>
            {/* Mobile Actions */}
            <Box sx={{display: {lg: "none"}, position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1200 }}>
                <StyledBottomNav>
                    <BottomNavigationAction onClick={() => setUploadFileModalOpen(true)} label="فایل جدید" icon={<UploadFileOutlined/>}/>
                    <BottomNavigationAction onClick={() => setCreateFolderModal(true)} label="پوشه جدید" icon={<CreateNewFolderOutlined/>}/>
                    <BottomNavigationAction onClick={handleToggleMultiple} label={multipleSelect ? "چند انتخابی" : "تک انتخابی"} icon={multipleSelect ? <TouchAppOutlined/> : <PanToolAltOutlined/>}/>
                    <Fade in={!!selectedItems.length} unmountOnExit>
                        <BottomNavigationAction
                            label="سایر موارد"
                            icon={<MoreVertRounded/>}
                            id="basic-button"
                            aria-controls={actionsMenuOpen ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={actionsMenuOpen ? 'true' : undefined}
                            onClick={handleOpenActionsMenu}/>
                    </Fade>
                </StyledBottomNav>
            </Box>
        </Root>
    )
}
export default Toolbar;

const Root = styled(Box)(({theme}) => ({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: 'column',
    "&.Mui-sticky": {
      position: "sticky",
      top: "20rem",
    },
    [theme.breakpoints.up('lg')]: {
        flexDirection: "row",
        flexWrap: 'wrap',
    },
}));
Root.defaultProps = {
    component: "section"
}

const StyledBottomNav = styled(BottomNavigation)(({theme}) => ({
    minHeight: "5rem",
    boxShadow: "0 -6px 12px -6px rgb(66 66 66 / 25%)",
    [`& .${bottomNavigationActionClasses.root}`]: {
        // color: theme.palette.primary.main
    }
}));
StyledBottomNav.defaultProps = {
    showLabels: true
}
